// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImagePreviewUI__wrapper___33ujQ","overlay":"ImagePreviewUI__overlay___vQXqD"};